export const paymentTypes = [
  "CARD",
"BANK",
"WALLET"
]